function DeleteIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.24598 10.0811C4.01681 10.0811 3.82202 10.0008 3.6616 9.84043C3.50119 9.68001 3.42098 9.48522 3.42098 9.25605V3.43522H2.96265V2.74772H5.02515V2.34668H7.77515V2.74772H9.83765V3.43522H9.37931V9.25605C9.37931 9.48522 9.29911 9.68001 9.13869 9.84043C8.97827 10.0008 8.78348 10.0811 8.55431 10.0811H4.24598ZM8.69181 3.43522H4.10848V9.25605C4.10848 9.29425 4.12192 9.32679 4.14881 9.35368C4.1754 9.38026 4.20779 9.39355 4.24598 9.39355H8.55431C8.58487 9.39355 8.61542 9.37828 8.64598 9.34772C8.67654 9.31717 8.69181 9.28661 8.69181 9.25605V3.43522ZM5.20848 8.47689H5.89598V4.35189H5.20848V8.47689ZM6.90431 8.47689H7.59181V4.35189H6.90431V8.47689ZM4.10848 3.43522V9.39355V9.25605V3.43522Z"
        fill="#4A4A4A"
      />
    </svg>
  );
}

export default DeleteIcon;
